<carousel [noWrap]="noWrapSlides">
  <slide *ngFor="let slide of slides; let index=index">
    <img [src]="slide.image" alt="image slide" style="display: block; width: 100%;">

    <div class="carousel-caption">
      <h4>Slide {{index}}</h4>
      <p>{{slide.text}}</p>
    </div>
  </slide>
</carousel>
<br/>
<div>
  <div class="checkbox">
    <label><input type="checkbox" [(ngModel)]="noWrapSlides">Disable Slide Looping</label>
  </div>
</div>
